import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Card from '../../../../components/card/card.component';
import classes from './styles.module.scss';
import { useKato } from '../../../../contexts/kato.context';
import { CommentIcon, FacebookIcon, InstagramIcon, LikeIcon, ShareIcon, TGIcon, VKIcon, YTIcon } from '../../../../assets/icons/mm';
import { useParams } from 'react-router-dom';
import { getMMData } from '../../../../requests/public.request';
import { IMediaMonitoringData } from '../../../../types/kato.types';

const baseClass = 'media-monitoring-card';
const translationKey = 'cards.media-monitoring-card';

const valueToIcon: Record<number, React.ReactNode> = {
    1: <InstagramIcon />,
    2: <FacebookIcon />,
    3: <VKIcon />,
    4: <YTIcon />,
    5: <TGIcon />
}

const MediaMonitoringCard = () => {
    const { t } = useTranslation();
    const { getCurrentKato } = useKato();
    const { kato } = useParams<{ kato: string }>();
    const [data, setData] = useState<IMediaMonitoringData[]>([]);

    const onClick = () => {
        const regionName = getCurrentKato()?.nameRu || getCurrentKato()?.nameKz;
        if (!regionName) return;
        window.open(`https://mm.csi.kz/main?keyword=${regionName.split(' ')[0].toLowerCase()}&clientid=aktobe-ea&realm=aktobe-sic`, '_blank');
    }

    useEffect(() => {
        getMMData(kato).then((data) => {
            const sortedAndFilteredData = data.sort((a, b) => {
                return b.likeSum - a.likeSum;
            }).slice(0, 3)
            setData(sortedAndFilteredData);
        }).catch((error) => {
            console.error(error);
        });
    }, [kato]);
    return (
        <Card
            title={t(`${translationKey}.title`)}
            onClick={onClick}
        >
            <div className={classes[baseClass]}>
                <div className={classes[`${baseClass}__table`]}>
                    <table>
                        <thead>
                            <tr>
                                <th>{t(`${translationKey}.publications`)}</th>
                                <th><div data-tooltip={t(`${translationKey}.likes`)} data-tooltip-position="bottom"><LikeIcon /></div></th>
                                <th><div data-tooltip={t(`${translationKey}.comments`)} data-tooltip-position="left"><CommentIcon /></div></th>
                                <th><div data-tooltip={t(`${translationKey}.shares`)} data-tooltip-position="left"><ShareIcon /></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className={classes[`${baseClass}__item`]}>
                                                <div className={classes[`${baseClass}__icon`]}>
                                                    {item.socialNet && valueToIcon[item.socialNet]}
                                                </div>
                                                <a href={item.url} className={classes[`${baseClass}__text`]}>
                                                    {item.text}
                                                </a>
                                            </div>
                                        </td>
                                        <td>{item.likeSum ?? 0}</td>
                                        <td>{item.commentSum ?? 0}</td>
                                        <td>{item.sharedSum ?? 0}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    )
}

export default MediaMonitoringCard